<template>
  <div class="inner-dashboard">
    <loading
      v-model:active="campaignLoading"
      :is-full-page="true"
      loader="dots"
      :opacity="1"
    />
    <PropertyDashboardSidebarNav
      v-if="!campaignLoading"
      :propertyId="propertyId"
      :campaignId="activeCampaignId"
      :showLeadIntro="showLeadIntro"
      :showTopIntro="showTopIntro"
    />
    <div class="container h-100 pt-4" v-if="!campaignLoading">
      <div
        class="property-dashboard-content-heading row justify-content-between"
      >
        <div class="heading-text col-12 col-md-6 mb-4">
          <div class="current-property">
            <button
              class="navbar-toggler ms-auto d-inline d-lg-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasMenu"
              aria-controls="offcanvasMenu"
            >
              <font-awesome-icon icon="compass" />
            </button>
            {{ campaignName }}
          </div>
          <div class="current-route">Ad Overview</div>
        </div>
        <div
          class="col-12 col-md-6 buttons d-flex justify-content-end"
          v-if="campaignName"
        >
          <button
            type="button"
            class="btn btn-primary wti-btn wti-btn-white share-button"
            data-bs-toggle="modal"
            data-bs-target="#shareReportURL"
          >
            Share URL
          </button>
          <button
            type="button"
            class="btn btn-primary wti-btn wti-btn-white share-button ms-4"
            @click="generatePDF"
            :disabled="!isPDFDownloadReady"
          >
            <span
              v-if="!isPDFDownloadReady"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ !isPDFDownloadReady ? "" : "Download PDF" }}
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end" v-if="addToDropdown">
        <div class="">
          <select class="form-select campaign-select" v-model="vtsCampaign">
            <option
              v-for="(item, key) in vtsCampaigns"
              :key="key"
              :value="item._id"
            >
              {{ item.campaignName }}
            </option>
          </select>
        </div>
      </div>
      <AdOverview
        v-if="activeCampaignId"
        :propertyId="propertyId"
        :campaignId="activeCampaignId"
        @updateCampaignData="updateCampaignData"
        @updateTenantCompaniesData="updateTenantCompaniesData"
        @updateWebsitesData="updateWebsitesData"
        @updateChannelData="updateChannelData"
        @updateLikesData="updateLikesData"
        @enablePDFDownload="enablePDFDownload"
      />
    </div>
  </div>
  <Modal id="shareReportURL">
    <template v-slot:title>Shareable URL</template>
    <template v-slot:body>
      <p class="border section mt-2 text-break">{{ publicUrl }}</p>
      <button
        type="button"
        v-clipboard:copy="publicUrl"
        class="btn btn-dark wti-btn-black"
      >
        Copy
      </button>
    </template>
  </Modal>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
.buttons .btn.share-button
  line-height: 16px
  +mobile
    margin-bottom: 10px
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import moment from "moment";
import PropertyDashboardSidebarNav from "@/components/PropertyDashboardSidebarNav.vue";
import AdOverview from "@/components/AdOverview.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "AdOverviewView",
  setup(props) {
    return {
      addToDropdown: ref(false),
      campaignName: ref(null),
      publicUrl: ref(null),
      campaignLoading: ref(false),
      campaignData: ref(null),
      topWebsites: ref(null),
      isPDFDownloadReady: ref(false),
      activeCampaignId: ref(null),
      tenantCompaniesData: ref(null),
      detailChannelData: ref(null),
      vtsCampaigns: ref([]),
      vtsCampaign: ref(null),
      campaignLikes: ref(null),
      showLeadIntro: ref(null),
      showTopIntro: ref(null),
    };
  },
  props: {
    propertyId: {
      type: String,
      required: true,
    },
    campaignId: {
      type: String,
      required: true,
    },
  },
  components: {
    PropertyDashboardSidebarNav,
    AdOverview,
    Modal,
  },
  computed: {},
  methods: {
    getCampaignInfo() {
      var info = {
        campaignId: this.activeCampaignId,
        templateName: "adOverview",
      };
      var _this = this;
      _this.campaignLoading = true;
      api()
        .getCampaignName(info)
        .then((res) => {
          if (res.data) {
            _this.campaignName = res.data.campaignName;
            _this.addToDropdown = res.data.addToDropdown;
            if (_this.addToDropdown) {
              _this.getVtsCampaigns();
            }
            _this.publicUrl = res.data.publicUrl;
            var monthlyBudget = res.data.monthlyBudget;
            var showLeadContacts = res.data.showLeadContacts;
            var showTopContacts = res.data.showTopContacts;
            _this.showLeadIntro =
              !showLeadContacts && monthlyBudget && monthlyBudget < 1000;
            _this.showTopIntro =
              !showTopContacts && monthlyBudget && monthlyBudget < 1000;
            _this.campaignLoading = false;
          }
        });
    },
    getVtsCampaigns() {
      var info = {
        propertyId: this.propertyId,
      };
      var _this = this;
      _this.campaignLoading = true;
      api()
        .getVtsCampaigns(info)
        .then((res) => {
          if (res.data) {
            _this.vtsCampaigns = res.data;
            _this.vtsCampaign = _this.activeCampaignId;
            _this.campaignLoading = false;
          }
        });
    },
    updateCampaignData(value) {
      this.campaignData = value;
    },
    updateTenantCompaniesData(value) {
      this.tenantCompaniesData = value;
    },
    updateWebsitesData(value) {
      this.topWebsites = value;
    },
    updateChannelData(value) {
      this.detailChannelData = value;
    },
    updateLikesData(value) {
      this.campaignLikes = value;
    },
    enablePDFDownload(value) {
      this.isPDFDownloadReady = value;
    },
    generatePDF() {
      var campaignName = this.campaignName;
      var reportData = {
        campaignName: campaignName,
        campaignData: this.campaignData,
        topWebsites: this.topWebsites,
        detailChannelData: this.detailChannelData,
        tenantCompaniesData: this.tenantCompaniesData,
        campaignLikes: this.campaignLikes,
      };
      var info = {
        reportData: reportData,
        templateName: "adOverview",
      };
      api()
        .generateReportPDFNew(info)
        .then((response) => {
          if (response.data instanceof Blob) {
            const fileURL = URL.createObjectURL(response.data);
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `${campaignName}-Ad_Overview.pdf`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            URL.revokeObjectURL(fileURL);
          } else {
            console.error("Unexpected response data type:", response.data);
          }
        })
        .catch((error) => {
          console.error("PDF download failed:", error);
        });
    },
  },
  mounted() {
    this.activeCampaignId = this.campaignId;
    this.getCampaignInfo(this.activeCampaignId);
  },
  watch: {
    vtsCampaign(val) {
      if (val) {
        this.activeCampaignId = val;
        this.getCampaignInfo(val);
      }
    },
  },
};
</script>
